// Turkse teksten voor gemiste taken in de ouderapp (zie missedApp.nl.ts).
export const appMissedTr = {
    line: {
        one: 'Geçen hafta {count} görev kaçırıldı',
        other: 'Geçen hafta {count} görev kaçırıldı',
    },
    lineSub: 'Sonradan işaretle veya atla',
    open: 'Göster',
    title: 'Kaçırılanlar',
    description: 'Geçen haftadan açık kalan görevler. Sonradan işaretleyin veya atlayın. Puanlar o günkü gibi sayılır.',
    done: 'Sonradan yapıldı',
    doneLabel: 'Sonradan yapıldı: {title}, {name}',
    skip: 'Atla',
    skipLabel: 'Atla: {title}, {name}',
    undo: 'Geri al',
    undoLabel: 'Geri al: {title}, {name}',
    markedDone: '{title} sonradan işaretlendi',
    markedSkipped: '{title} atlandı',
    undone: '{title} yeniden kaçırılanlarda',
    stateDone: 'Yapıldı',
    stateSkipped: 'Atlandı',
    allDone: 'Kaçırılan görev kalmadı. Her şey güncel.',
};
//# sourceMappingURL=missedApp.tr.js.map